import type { JSX } from "react";

/**
 * The clock beside the header's local-time vital, drawn as stroke paths in
 * `currentColor` so it inherits the label's colour and scales with the mono
 * text. Hands at ten past two, the reading every clock icon uses, because a
 * clock showing twelve o'clock reads as a circle at this size. Decorative: the
 * ticking time it sits beside carries the reading for a screen reader.
 */
export function ClockGlyph(): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="8.4" />
      <path d="M12 7.4V12l3.4 2.1" />
    </svg>
  );
}
